// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./js/subscription/" + {"49277":"subscription.subscription-input-syncer.plugin","60001":"subscription.subscription-product-box.plugin"}[chunkId] + "." + {"49277":"3f9735","60001":"f11e2f"}[chunkId] + ".js";
};